import { array, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import action from './appSebraeSearchAddressResolve.action.json'
import {
  googleMapsInteractionFields,
  googlePlacesPresentationFields,
  googlePlacesStatus,
} from '../searchAddressGoogle.contract'

export default defineAction({
  ...action,
  operation: 'read' as const,
  userActivityLog: true,
  input: object({
    source: enumerated({ google_places: 'google_places' }).isOptional(),
    placeId: string(),
    ...googleMapsInteractionFields,
  }),
  output: object({
    status: googlePlacesStatus,
    result: object({
      ...googlePlacesPresentationFields,
      displayAddress: string(),
      streetName: string().isOptional(),
      number: string().isOptional(),
      neighborhoodName: string().isOptional(),
      cityName: string().isOptional(),
      stateAbbreviation: string().isOptional(),
      postalCode: string().isOptional(),
      countryCode: string().isOptional(),
      latitude: number(),
      longitude: number(),
      provenance: object({ source: string(), placeId: string(), resolvedAt: dateTime() }),
    }).isOptional(),
  }),
})
